<div class="whatsapp-qr-body">
  <div *ngIf="state === 'loading'" class="state-loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 mb-0">Preparing QR code...</p>
  </div>
  <div *ngIf="state === 'qr'" class="state-qr">
    <div class="qr-wrapper" *ngIf="qrDataUrl">
      <img [src]="qrDataUrl" alt="WhatsApp QR Code" class="qr-image" />
    </div>
    <p class="mt-3 mb-0 text-muted">Scan this QR code with WhatsApp on your phone to connect.</p>
  </div>
  <div *ngIf="state === 'connected'" class="state-connected">
    <p class="text-success mb-0">Connected. Closing...</p>
  </div>
  <div *ngIf="state === 'expired'" class="state-expired">
    <p class="text-warning mb-2">QR code expired.</p>
    <button type="button" class="btn btn-primary" (click)="retry()">Try again</button>
  </div>
  <div *ngIf="state === 'error'" class="state-error">
    <p class="text-danger mb-2">{{ errorMessage }}</p>
    <button type="button" class="btn btn-primary" (click)="retry()">Try again</button>
  </div>
</div>
